import { Box } from "@mui/material";
import { optionSx } from "./styles";

export default function RenderOption({
  option,
  outerOption = option,
  onSelect,
  value,
  active,
  innerDataIndex,
  setActive,
  index,
  inputFieldRef,
  dataIdx,
}) {
  return (
    <Box
      data-idx={dataIdx}
      inner-data-idx={innerDataIndex}
      onClick={() => {
        if (option === null) return;
        setActive(index);
        onSelect(
          outerOption.key,
          outerOption.label,
          outerOption.getOptionValue?.(option) ?? value
        );
        queueMicrotask(() => inputFieldRef.current.focus());
      }}
      sx={[
        optionSx(active),
        {
          cursor: option === null ? "default" : "pointer",
          "@media (hover: hover)": {
            "&:hover": {
              bgcolor:
                option === null
                  ? "none"
                  : active
                  ? "action.selected"
                  : "action.hover",
            },
          },
          color: option === null ? "gray" : "default",
          height: 32,
          display: "flex",
          alignItems: "center",
          py: 0,
        },
      ]}
    >
      {option !== null
        ? outerOption.getOptionLabel?.(option) ?? `${option.label} = ${value}`
        : "No Options"}
    </Box>
  );
}
